import React from 'react';
import ReactDOM from 'react-dom/client';
// import './styles/index.css';
import LoginPage from './components/loginPage';
import Main from './components/Main';
import reportWebVitals from './reportWebVitals';
import './styles/index.scss'; 


import {  HashRouter, Routes, Route, Navigate } from 'react-router-dom';

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <LoginPage />
//   </React.StrictMode>
// );

function App() {

    
  
  return (
  <React.StrictMode>
    <title>Honeywell HelpBot</title>
      <HashRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={ !!sessionStorage.getItem('accessToken') ? <Main /> :<Navigate replace to="/login" />} />
        </Routes>
      </HashRouter>

  </React.StrictMode>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
